export class MessageTip {
  static callBack = () => {}; //页面回调时重写函数
  static message = {
    show: false,
    onShow: () => {
      MessageTip.message.show = true;
    },
    onClose: () => {
      MessageTip.message.show = false;
    },
    onAdd: (title, info = {}) => {
      MessageTip.info = { ...info };
      MessageTip.info.title = title; //弹框标题
      MessageTip.message.show = true;
    },
  };
  static onShow = () => {
    MessageTip.message.onShow();
  };
  static onClose = () => {
    MessageTip.message.onClose();
  };
  static onAdd = (title, info = {}) => {
    MessageTip.message.onAdd(title, info);
  };
}
